
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexpLQp9qDFEt15WbCzlp7Qevvy_3Xru_hH9FZSmrty1koMeta } from "/codebuild/output/src4043575844/src/nuxt/pages/index.vue?macro=true";
import { default as signup_kaXfGM8Swc5mD8eeIwGOVaJbZgWOjqQjecMi9JyVHEMeta } from "/codebuild/output/src4043575844/src/nuxt/pages/signup.vue?macro=true";
import { default as contactVw_T_vcfnpkpb4zbk8pLe4UipjuswtECRBHWI5VQ3BcMeta } from "/codebuild/output/src4043575844/src/nuxt/pages/contact.vue?macro=true";
import { default as cookiesjOuFh6FKicJNaKnZ2e8nzTqheNZ59V4KHbOnyyJdWUIMeta } from "/codebuild/output/src4043575844/src/nuxt/pages/cookies.vue?macro=true";
import { default as editWwrtiICW2GDArI_KMjk_3vvvciVpm4dw4OEFrkUm47gMeta } from "/codebuild/output/src4043575844/src/nuxt/pages/me/edit.vue?macro=true";
import { default as privacybgWySJWQczavZ0Z3Wa0T_3EhHkMyMOB7X4_p6A_DvuUMeta } from "/codebuild/output/src4043575844/src/nuxt/pages/privacy.vue?macro=true";
import { default as indexDn6aO_Rdtv_vbzSpkslslqzf2I5urrHl_lfnhI5OTEMMeta } from "/codebuild/output/src4043575844/src/nuxt/pages/me/index.vue?macro=true";
import { default as _91passcode_9388NbH1Rm_71P5qD_IPBgKPRJ8JpKOVqG_gq5Wh1G_H8Meta } from "/codebuild/output/src4043575844/src/nuxt/pages/login/index/[passcode].vue?macro=true";
import { default as index4KbyeuQTZGuUYinGDvY52D7t5YYkuTLX54rTai7a204Meta } from "/codebuild/output/src4043575844/src/nuxt/pages/login/index.vue?macro=true";
import { default as _91token_93bMolYJIWyuppjFuOVyuE2Qh8XT8ZNrYKDAnWRBRKdWEMeta } from "/codebuild/output/src4043575844/src/nuxt/pages/messages/index/[idThread]/[token].vue?macro=true";
import { default as _91idThread_93ShDzs6PfUgMDJr3tJ1VcybvHgcdwF3Du_QGiVUyoKJsMeta } from "/codebuild/output/src4043575844/src/nuxt/pages/messages/index/[idThread].vue?macro=true";
import { default as indexPWFthNNmQICrCqF9LKLBNkPtYVec__gJf3OktT1MbKkMeta } from "/codebuild/output/src4043575844/src/nuxt/pages/messages/index.vue?macro=true";
import { default as indexXRJC6ZsnmKfcprG32uJBTgNkLYFE_ZOIBG8K7S5S8fsMeta } from "/codebuild/output/src4043575844/src/nuxt/pages/login-code/index.vue?macro=true";
import { default as notificationseALULorY2xDjbU9_NZvwUOCq1u_7GmJAe7WI5dd_4_MMeta } from "/codebuild/output/src4043575844/src/nuxt/pages/me/notifications.vue?macro=true";
import { default as _91token_93FPhZPpoYZd0Om6vbMLhCq3mLRCfPo9rdlmobDb89GRoMeta } from "/codebuild/output/src4043575844/src/nuxt/pages/unsubscribe/[email]/[token].vue?macro=true";
import { default as _91token_93uFVFfuMC99ECK_XrCEt11nLbTnZSKp22cbYk_f01rR4Meta } from "/codebuild/output/src4043575844/src/nuxt/pages/unsubscribe-mailers/[email]/[token].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src4043575844/src/nuxt/pages/index.vue")
  },
  {
    name: "signup",
    path: "/signup",
    component: () => import("/codebuild/output/src4043575844/src/nuxt/pages/signup.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src4043575844/src/nuxt/pages/contact.vue")
  },
  {
    name: "cookies",
    path: "/cookies",
    component: () => import("/codebuild/output/src4043575844/src/nuxt/pages/cookies.vue")
  },
  {
    name: "me-edit",
    path: "/me/edit",
    meta: editWwrtiICW2GDArI_KMjk_3vvvciVpm4dw4OEFrkUm47gMeta || {},
    component: () => import("/codebuild/output/src4043575844/src/nuxt/pages/me/edit.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/codebuild/output/src4043575844/src/nuxt/pages/privacy.vue")
  },
  {
    name: "me",
    path: "/me",
    meta: indexDn6aO_Rdtv_vbzSpkslslqzf2I5urrHl_lfnhI5OTEMMeta || {},
    component: () => import("/codebuild/output/src4043575844/src/nuxt/pages/me/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/codebuild/output/src4043575844/src/nuxt/pages/login/index.vue"),
    children: [
  {
    name: "login-index-passcode",
    path: ":passcode()",
    component: () => import("/codebuild/output/src4043575844/src/nuxt/pages/login/index/[passcode].vue")
  }
]
  },
  {
    name: "messages",
    path: "/messages",
    component: () => import("/codebuild/output/src4043575844/src/nuxt/pages/messages/index.vue"),
    children: [
  {
    name: "messages-index-idThread",
    path: ":idThread()",
    component: () => import("/codebuild/output/src4043575844/src/nuxt/pages/messages/index/[idThread].vue"),
    children: [
  {
    name: "messages-index-idThread-token",
    path: ":token()",
    component: () => import("/codebuild/output/src4043575844/src/nuxt/pages/messages/index/[idThread]/[token].vue")
  }
]
  }
]
  },
  {
    name: "login-code",
    path: "/login-code",
    component: () => import("/codebuild/output/src4043575844/src/nuxt/pages/login-code/index.vue")
  },
  {
    name: "me-notifications",
    path: "/me/notifications",
    meta: notificationseALULorY2xDjbU9_NZvwUOCq1u_7GmJAe7WI5dd_4_MMeta || {},
    component: () => import("/codebuild/output/src4043575844/src/nuxt/pages/me/notifications.vue")
  },
  {
    name: "unsubscribe-email-token",
    path: "/unsubscribe/:email()/:token()",
    component: () => import("/codebuild/output/src4043575844/src/nuxt/pages/unsubscribe/[email]/[token].vue")
  },
  {
    name: "unsubscribe-mailers-email-token",
    path: "/unsubscribe-mailers/:email()/:token()",
    component: () => import("/codebuild/output/src4043575844/src/nuxt/pages/unsubscribe-mailers/[email]/[token].vue")
  }
]